import { BlocksTitle } from '@components/Blocks/shared/BlocksTitle';
import { Maybe } from '@lib/types/Maybe';
import { Link } from 'ui-components';

export const ProductRowHeading = ({
  title,
  description,
  text,
  textPlain,
  link,
  onLinkClick,
}: {
  title: Maybe<string>;
  description?: string | null; // HTML string
  text?: string | null; // HTML string
  textPlain?: string | null; // Plain text for aria-label
  link?: { href: string; label: string };
  onLinkClick?: (label: string) => void;
}) => {
  const linkAriaLabelFallbackText = textPlain ?? '';

  let linkAriaLabel = link?.label ?? '';

  if (title) {
    linkAriaLabel += ` ${title}`;
  } else if (linkAriaLabelFallbackText) {
    linkAriaLabel += ` ${linkAriaLabelFallbackText}`;
  }

  return (
    <div className="container mb-3 flex items-start justify-between self-stretch">
      {(title || description || text) && (
        <div>
          <BlocksTitle title={title} description={description} text={text} />
        </div>
      )}
      {link && (
        <Link.v2
          data-test="product-row-heading-link"
          variant="secondary"
          size="medium"
          href={link.href}
          onClick={() => onLinkClick && onLinkClick(link.label)}
          aria-label={linkAriaLabel}
        >
          {link.label}
        </Link.v2>
      )}
    </div>
  );
};
